import { PartialDeep } from "type-fest";

import { ChecklistRole, pageBreak } from "./checklistAppState";
import { ChecklistDocumentOptions } from "./documentOptions";
import { ChecklistDocumentStyles, ChecklistElementStyles } from "./documentStyles";
import { DocumentLayout } from "./layout";

export interface SerializedChecklistDocument {
  title: string;
  contents: SerializedChecklistContents;
  styles: PartialDeep<ChecklistDocumentStyles>;
  layout: DocumentLayout;
  options: ChecklistDocumentOptions;
}

export interface SerializedChecklistContents {
  title: string;
  checklists: Array<SerializedChecklistDocumentElement>;
}

export type SerializedChecklistDocumentElement = SerializedChecklist | SerializedPageBreak;

export interface SerializedChecklist {
  title: string;
  content: Array<SerializedChecklistElement>;
  role?: ChecklistRole[];
}

export type SerializedChecklistElement = SerializedChecklistItem | SerializedChecklistHeader;

export interface SerializedChecklistItem {
  item: string;
  setting: string;
  styles?: ChecklistElementStyles;
}

export interface SerializedChecklistHeader {
  header: string;
  styles?: ChecklistElementStyles;
}

export function isSerializedChecklistItem(
  element: SerializedChecklistElement
): element is SerializedChecklistItem {
  return (
    (element as SerializedChecklistItem).item !== undefined &&
    (element as SerializedChecklistItem).setting !== undefined
  );
}

export function isSerializedChecklistHeader(
  element: SerializedChecklistElement
): element is SerializedChecklistHeader {
  return (element as SerializedChecklistHeader).header !== undefined;
}

export type SerializedPageBreak = typeof pageBreak;

export function isSerializedPageBreak(
  element: SerializedChecklistDocumentElement
): element is SerializedPageBreak {
  return (element as SerializedPageBreak) === pageBreak;
}

export function isSerializedChecklist(
  element: SerializedChecklistDocumentElement
): element is SerializedChecklist {
  return (
    (element as SerializedChecklist).title !== undefined &&
    (element as SerializedChecklist).content !== undefined
  );
}
